

























import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class MainButton extends Vue {
  @Prop() text!: string;

  @Prop() color!: string;

  @Prop() dark!: boolean;

  @Prop() font!: boolean;

  @Prop() disabled!: boolean;

  @Prop() height!: string;

  @Prop() width!: string;

  @Prop() customStyle!: string;

  @Prop() ariaLabel?: string;

  @Prop({
    required: false,
    default: 'auto',
  })
  contentWidth!: string;

  @Prop({
    required: false,
    default: '10px',
  })
  fontSize!: string;

  @Prop({
    required: false,
    default: 'normal',
  })
  lineHeight!: string;

  @Prop({
    required: false,
    default: '0px',
  })
  margin!: string;

  @Prop({
    required: false,
    default: false,
  })
  outlined!: boolean;

  @Prop({
    type: String,
    default: 'white',
  }) textColor!: string;

  @Prop({
    type: Boolean,
    default: false,
  }) loading!: boolean;

  click() {
    this.$emit('click');
  }
}

